import ChartTrendIcon from '@atlaskit/icon/core/chart-trend';
import * as React from 'react';

export function SvgChart() {
  return <ChartTrendIcon label="" testId="ads-refreshed-icon" />;
}
